<template>
  <v-row :justify="justify">
    <v-col cols="12" xl="8">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <div grid-list-xl>
          <form-toolbar
            :class="toolbarColor"
            :title="title"
            :loading="form.busy"
            @save="save"
            @cancel="cancel"
          />
          <v-layout
            :id="ref"
            class="wrap form-body"
          >
            <v-col
              cols="5"
              md="5"
            >
              <v-select
                v-model="form.type_document"
                :items="items_type_document"
                :rules="[rules.required]"
                label="Tipo de Documento"
                placeholder="Tipo de Documento"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="5"
              md="5"
              lg="5"
            >
              <v-text-field
                v-model="form.rif"
                :rules="[rules.required, rules.rucLength, rules.rucFormat]"
                v-mask="'A-#########'"
                label="Número de Identificación"
                maxlength="11"
                placeholder="RIF"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="2"
              md="2"
              lg="2"
            >
              <v-btn
                class="ml-1"
                color="success"
                :loading="form.busy"
                @click="save"
                v-if="id && can('editar_datos_empresa')"
              >
                <v-icon text>
                  mdi-content-save-edit
                </v-icon>
              </v-btn>
            </v-col>
            <v-col
               cols="12"
               md="6">
                <v-select
                  v-model="form.taxpayer_type"
                  :items="items_taxpayer_type"
                  :rules="[rules.required]"
                  label="Tipo de Contribuyente"
                  placeholder="Tipo de Contribuyente"
                  required
                  :readonly="readonly"
                />
              </v-col>
              <!-- <v-col
                  cols="12"
                  md="6">
                  <v-select
                    v-model="form.special_tax"
                    :items="items_special_tax"
                    label="Régimen Especial de Tributación"
                    placeholder="Régimen Especial de Tributación"
                    :readonly="readonly"
                  />
            </v-col> -->
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.name"
                :rules="[rules.required]"
                label="Razón Social"
                placeholder="Razón Social"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              >
              <v-text-field
                v-model="form.email"
                :rules="[rules.required, rules.emailFormat]"
                label="Correo Electrónico"
                placeholder="ejemplo@dominio.com"
                required
                :readonly="readonly"
              />
            </v-col>
            <!-- <v-col
                cols="12"
                md="12"
                >
              <vuetify-select-api
                :api="activity.apiActivities"
                :multiple="activity.multiple"
                :placeholder="activity.placeholder"
                @eventupdate="updateActivities"
                :selected="activity.selectedActivities"
              />
            </v-col> -->
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.branch_code"
                :rules="[rules.required, rules.alphanumeric, rules.codeLength]"
                label="Sucursal"
                maxlength="4"
                placeholder="0001"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-select
                v-model="form.cat_province_id"
                :items="itemsProvince"
                item-value="id"
                item-text="name"
                :rules="[rules.required]"
                label="Estado"
                required
                @change="getDistrito()"
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-select
                v-model="form.cat_district_id"
                :items="itemsDistrict"
                item-value="id"
                item-text="name"
                :rules="[rules.required]"
                label="Municipio"
                required
                @change="getCorregimiento()"
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="4">
              <v-select
                v-model="form.cat_corregimiento_id"
                :items="itemsMunicipality"
                item-value="id"
                item-text="name"
                :rules="[rules.required]"
                label="Parroquia"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="9"
            >
              <v-text-field
                v-model="form.address"
                :rules="[rules.required]"
                label="Dirección"
                placeholder="Dirección"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="form.phone"
                 v-mask="'####-###-####'"
                :rules="[rules.required, rules.phoneLength]"
                label="Teléfono"
                placeholder="0123-456-7890"
                maxlength="13"
                type="tel"
                required
                :readonly="readonly"
              />
            </v-col>
          </v-layout>
        </div>
      </v-form>
    </v-col>
  </v-row>
  </template>

<script>
    import { mapGetters } from 'vuex';
    import Form from 'vform';
    import { mask } from 'vue-the-mask';
    import FormToolbar from '~/components/Form/Toolbar';
    // import VuetifySelectApi from '~/components/VuetifySelectApi';

    export default {
      components: {
        FormToolbar,
        // VuetifySelectApi,
      },
      metaInfo() {
        return { title: this.$t('enterprises') };
      },
      directives: {
        mask,
      },
      props: {
        dealerId: {
          default: '',
        },
      },
      data: () => ({
        form: new Form({
          dealer_id: null,
          type_document: null,
          rif: null,
          taxpayer_type: null,
          special_tax: null,
          name: null,
          email: null,
          phone: null,
          address: null,
          branch_code: null,
          cat_corregimiento_id: null,
          cat_district_id: null,
          cat_province_id: null,
          active: '1',
          notify_fel: '0',
          send_mail: '0',
          busy: false,
          actividad: [],
          notifyRecepcion: '0',
          sales_book: '0',
          batches: '0',
          logs: '0',
          web_billing: '0',
          annulment: '0',
          retention: '0',
          receipt: '0',
          send_sms: '0',
          association_task: '0',
          activities_code: [],
          delivery_method: '0',
          modality: '0',
          negotiate_controls: '0',
          send_order: '0',
          mode_order: '0',
          send_whatsapp: '0',
          code_qr: '0',
          send_file_whatsapp: '0',
          whatsapp_provider: '0',
          folder: '',
          payment: '0',
          onlyIGTF: '0',
          seller_id: null,
        }),
        cc_email: '',
        app: '',
        loadingNotify: false,
        dialogStatusNotify: false,
        loadingWebBilling: false,
        dialogStatusWebBilling: false,
        url: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg',
        searching: false,
        unavailable: false,
        loading: false,
        previousSearch: '',
        itemsProvince: [],
        itemsDistrict: [],
        itemsMunicipality: [],
        items_type_document: [
          { value: 'J', text: 'JURÍDICO' },
          { value: 'V', text: 'VENEZOLANO' },
          { value: 'C', text: 'CEDULA' },
          { value: 'P', text: 'PASAPORTE' },
          { value: 'G', text: 'GUBERNAMENTAL' },
          { value: 'E', text: 'EXTRANJERO' },
        ],
        items_taxpayer_type: [
          { value: 'FORMAL', text: '  FORMAL' },
          { value: 'ORDINARIO', text: 'ORDINARIO' },
          { value: 'ESPECIAL', text: 'ESPECIAL' },
          { value: 'NO SUJETO', text: 'NO SUJETO' },
        ],
        items_special_tax: [
          { value: 'ZONAS ECONÓMICAS ESPECIALES', text: 'ZONAS ECONÓMICAS ESPECIALES' },
          { value: 'ZONA FRANCA DE PARAGUANÁ', text: 'ZONA FRANCA DE PARAGUANÁ' },
          { value: 'ZONA LIBRE DE PARAGUANÁ', text: 'ZONA LIBRE DE PARAGUANÁ' },
          { value: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN', text: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN' },
          { value: 'ZONA LIBRE DE MÉRIDA', text: 'ZONA LIBRE DE MÉRIDA' },
          { value: 'PUERTO LIBRE EDO. NUEVA ESPARTA', text: 'PUERTO LIBRE EDO. NUEVA ESPARTA' },
          { value: 'DUTTY FREE', text: 'DUTTY FREE' },
          { value: 'OTROS', text: 'OTROS' },
        ],
        success: null,
        valid: false,
        readonly: false,
        rules: {
          required: (v) => !!v || 'El campo es requerido.',
          rucLength: (v) => (!v || v.length === 11) || 'El campo debe tener de 11 caracteres.',
          rucFormat: (v) => /^[V,J,E,P,G]{1}[-][0-9]{9}$/.test(v) || 'El formato no corresponde.',
          phoneLength: (v) => (!v || v.length === 13) || 'El campo debe tener de 11 caracteres numéricos.',
          codeLength: (v) => (!!v && v.length === 4) || 'El campo debe tener de 4 caracteres alfanumericos.',
          alphanumeric: (v) => /^[a-zA-Z0-9]*$/.test(v) || 'El campo solo permite caracteres alfanumericos.',
          emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
          numeric: (v) => /^[0-9]+$/.test(v) || 'El campo solo permite numeros.',
        },
        buttons: [
          {
            icon: 'mdi-content-save',
            name: 'Guardar',
          },
          {
            icon: 'mdi-close',
            name: 'Cancelar',
          },
        ],
        title: 'Nueva Empresa',
        method: 'POST',
        activity: {
          selectedActivities: null,
          apiActivities: '/api/catalogs/activities/Todos',
          multiple: true,
          placeholder: 'Actividades Comerciales',
        },
      }),
      computed: {
        ref() { return this.form.id; },
        apiURL() {
          return `/api/catalogs/dealers/${this.dealerId}/enterprises/storeDealer`;
        },
        enterprise() {
          return this.$store.state.profile.enterprise;
        },
        ...mapGetters({
          user: 'auth/user',
          themeColor: 'theme/themeColor',
          toolbarColor: 'theme/toolbarColor',
        }),
        justify() {
          return this.id && this.enterprise.type ? 'start' : 'center';
        },
      },
      watch: {
        'form.cat_province_id': {
          handler() {
            this.getDistrito();
          },
        },
        'form.cat_district_id': {
          handler() {
            this.getCorregimiento();
          },
        },
      },
      async mounted() {
        this.updateActivities(this.activity.selectedActivities);
        await this.getProvincia().then((response) => {
          this.itemsProvince = response.data;
        });
      },
      methods: {
        getEnterprises() {
          const url = `/api/enterprises/${this.id}`;
          return window.axios.get(url);
        },
        validate() {
          if (this.$refs.form.validate()) {
            this.form.busy = true;
            this.store();
          }
        },
        store() {
          this.form.dealer_id = this.dealerId;
          window.axios({
            method: this.method,
            url: this.apiURL,
            data: this.form,
          }).then(() => {
            this.$router.go(-1);
          })
          .finally(() => {
            this.form.busy = false;
          });
        },
        save() {
          this.validate(); // someValue
        },
        cancel() {
          this.$router.go(-1); // someValue
        },
        reset() {
          this.$refs.form.reset();
        },
        resetValidation() {
          this.$refs.form.resetValidation();
        },
        getProvincia() {
          const url = '/api/provinces';
          return window.axios.get(url);
        },
        getDistrito() {
          if (this.form.cat_province_id) {
              const url = `/api/districts/${this.form.cat_province_id}`;
              window.axios.get(url)
              .then((response) => {
              this.itemsDistrict = response.data;
            });
          }
        },
        getCorregimiento() {
          if (this.form.cat_district_id) {
              const url = `/api/corregimientos/${this.form.cat_district_id}`;
              window.axios.get(url)
              .then((response) => {
              this.itemsMunicipality = response.data;
            });
          }
        },
        updateActivities(activities) {
          this.form.activities_code = [];
          if (activities !== null) {
            activities.forEach((item) => {
              this.form.activities_code.push(item);
            });
          }
        },
      },
    };
</script>
